module.exports = __webpack_public_path__ + "static/media/girl-at-desk-success.484c6dbe.svg";